module.exports = __webpack_public_path__ + "static/media/stoveHalfOut.7f4d5a6f.gif";